import { Select } from "../../../components/select/Select";
import type { FC } from "react";
import { useProductOptions } from "../../dictionaries/useProductOptions";

interface Props {
  readonly value: string;
  readonly label: string;
  readonly size?: "small" | "medium";
  onChange: (value: string) => void;
}

const OptionNameSelect: FC<Props> = ({ value, label, size, onChange }) => {
  const { productOptions } = useProductOptions();

  return (
    <Select
      label={label}
      size={size}
      fullWidth
      value={value}
      values={productOptions.map(({ name }) => ({ value: name, name }))}
      onSelect={onChange}
    />
  );
};

export default OptionNameSelect;
